// src/components/ChatbotWithNavigation.tsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import EnhancedChatbot from './Chatbot';

const ChatbotWithNavigation: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Listen for the custom navigation events from the chatbot
    const handleNavigateToDocument = (event: any) => {
      // Extract document ID from the event
      const { documentId } = event.detail;

      // Use React Router's navigate to go to the document viewer
      // This prevents page reloads and maintains app state
      if (documentId) {
        navigate(`/documents/${documentId}`);
      }
    };

    // Add event listener
    window.addEventListener('navigate-to-document', handleNavigateToDocument);

    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener('navigate-to-document', handleNavigateToDocument);
    };
  }, [navigate]);

  return <EnhancedChatbot />;
};

export default ChatbotWithNavigation;